<template>
  <div class="all-buildings">
    <!-- Overall Statistics -->
    <div class="statistics-section mb-5">
      <h3>Overall Building Statistics</h3>
      <div v-if="loadingStats" class="text-center py-4">
        <circle-loader :size="30"></circle-loader>
      </div>
      <building-statistics 
        v-else
        :stats="allStats"
        :show-creator-stats="true"
      />
    </div>

    <!-- Enhanced Building Table -->
    <div class="table-section">
      <h3>All Buildings</h3>
      <enhanced-building-table
        :api-endpoint="'/services/v2/buildings/lookup'"
        :show-creator-column="true"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import CircleLoader from '@/components/CircleLoader'
import BuildingStatistics from '@/components/BuildingStatistics'
import EnhancedBuildingTable from '@/components/EnhancedBuildingTable'

export default {
  name: 'AllBuildingsPage',
  components: { 
    CircleLoader, 
    BuildingStatistics, 
    EnhancedBuildingTable 
  },
  data() {
    return {
      allStats: {},
      loadingStats: false
    }
  },
  methods: {
    async loadAllStats() {
      this.loadingStats = true
      try {
        const response = await axios.get('/services/v2/buildings/stats/all')
        this.allStats = response.data
      } catch (error) {
        console.error('Error loading all stats:', error)
        this.$bvToast.toast('Error loading statistics', {
          title: 'Error',
          variant: 'danger'
        })
      } finally {
        this.loadingStats = false
      }
    }
  },
  async mounted() {
    await this.loadAllStats()
  }
}
</script>

<style lang="scss" scoped>
.all-buildings {
  .statistics-section {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 2rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);

    h3 {
      color: #495057;
      margin-bottom: 1.5rem;
      font-weight: 600;
    }
  }

  .table-section {
    h3 {
      color: #495057;
      margin-bottom: 1.5rem;
      font-weight: 600;
    }
  }
}
</style>
